module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassicWeb-RegularItalic-8f0a31f60ce60324b6f3bcd2a6ae9b8e.woff";